export default {
  "logout-success": "登出成功",
  "logout-error": "登出失敗",
  "confirm": "確認",
  "copySuccess": "複製成功",
  "server": {
    "selectServer": "選擇伺服器",
    "serverAmerica": "America",
    "serverEurope": "Europe",
    "serverAsia": "Asia",
    "serverHMT": "HMT",
    "serverSEA": "SEA",
    "noRole": "暫無角色，請先進入遊戲",
    "noRole2": "暫無角色",
    "noOtherRole": "查詢不到其他角色，無法切換"
  },
  "uidlogin": { 
      "enterCode": "請輸入驗證碼",
      "enterCode2": "請輸入正確的驗證碼",
      "sendCode": "發送驗證碼",
      "agree": "請閱讀並同意《用戶協議》和《隱私政策》",
      "sended": "已發送",
      "tipUid": "請輸入UID",
      "tipUid2": "請輸入正確的UID",
      "login": "登錄",
      "loginFail": "登錄失敗,請檢查uid和驗證碼是否正確",
      "loginSuccess": "登錄成功",
      "sendFail": "查詢不到角色",
      "sendFail2": "發送失敗",
      "sendFast": "發送過於頻繁",
      "sendFast2": "發送過於頻繁,請在{time}後再試",
      "codeInvaild": "驗證碼已失效"
  },
  "share-tips": "長按保存圖片分享"
};
